import { render, staticRenderFns } from "./memberCardCheck.vue?vue&type=template&id=4b674200&"
import script from "./memberCardCheck.vue?vue&type=script&lang=js&"
export * from "./memberCardCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports